/* ==========================================================================
   Blog Article Enhancements — SaltBricks
   Add this file to: assets/blog-article-enhance.js
   Include with: <script src="{{ 'blog-article-enhance.js' | asset_url }}" defer></script>
   No liquid template restructuring needed — this script reads whatever
   headings/tables/blockquotes already exist inside .rte and enhances them.
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  var content = document.querySelector('.ba-content');
  if (!content) return; // article wrapper not found — see integration note in chat

  content.classList.add('rte'); // ensure existing theme rte styles still apply

  /* ---------- 1. Wrap every table for horizontal scroll on mobile ---------- */
  content.querySelectorAll('table').forEach(function (table) {
    if (table.closest('.ba-table-wrap')) return;
    var wrap = document.createElement('div');
    wrap.className = 'ba-table-wrap';
    table.parentNode.insertBefore(wrap, table);
    wrap.appendChild(table);
  });

  /* ---------- 2. Build Table of Contents from h2 elements ---------- */
  var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));
  var tocDesktop = document.getElementById('ba-toc-list');
  var tocMobile = document.getElementById('ba-toc-list-mobile');

  if (headings.length && (tocDesktop || tocMobile)) {
    headings.forEach(function (h, i) {
      if (!h.id) h.id = 'ba-section-' + (i + 1);

      if (tocDesktop) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        a.dataset.tocTarget = h.id;
        li.appendChild(a);
        tocDesktop.appendChild(li);
      }
      if (tocMobile) {
        var li2 = document.createElement('li');
        var a2 = document.createElement('a');
        a2.href = '#' + h.id;
        a2.textContent = h.textContent;
        li2.appendChild(a2);
        tocMobile.appendChild(li2);
        a2.addEventListener('click', function () {
          var details = document.querySelector('.ba-toc-mobile');
          if (details) details.removeAttribute('open');
        });
      }
    });

    /* Highlight active section on scroll */
    var tocLinks = tocDesktop ? tocDesktop.querySelectorAll('a') : [];
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var link = content.parentElement.querySelector(
          '.ba-toc__list a[data-toc-target="' + entry.target.id + '"]'
        );
        if (!link) return;
        if (entry.isIntersecting) {
          tocLinks.forEach(function (l) { l.classList.remove('is-active'); });
          link.classList.add('is-active');
        }
      });
    }, { rootMargin: '-20% 0px -70% 0px' });

    headings.forEach(function (h) { observer.observe(h); });
  }

  /* ---------- 3. Reading progress bar ---------- */
  var progress = document.querySelector('.ba-progress');
  if (progress) {
    window.addEventListener('scroll', function () {
      var scrollTop = window.scrollY;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      var pct = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      progress.style.width = pct + '%';
    }, { passive: true });
  }

  /* ---------- 4. Convert FAQ section into an accordion ----------
     Looks for an h2 containing "Frequently Asked Questions", then turns
     each following h3 (until the next h2) into a <details> accordion item. */
  var faqHeading = headings.find(function (h) {
    return /frequently asked questions/i.test(h.textContent);
  });

  if (faqHeading) {
    var node = faqHeading.nextElementSibling;
    while (node && node.tagName !== 'H2') {
      if (node.tagName === 'H3') {
        var question = node;
        var bodyNodes = [];
        var next = question.nextElementSibling;
        while (next && next.tagName !== 'H3' && next.tagName !== 'H2') {
          bodyNodes.push(next);
          next = next.nextElementSibling;
        }

        var details = document.createElement('details');
        details.className = 'ba-faq-item';
        var summary = document.createElement('summary');
        summary.textContent = question.textContent;
        details.appendChild(summary);

        var bodyWrap = document.createElement('div');
        bodyWrap.className = 'ba-faq-item__body';
        bodyNodes.forEach(function (n) { bodyWrap.appendChild(n); });
        details.appendChild(bodyWrap);

        question.replaceWith(details);
        node = next;
        continue;
      }
      node = node.nextElementSibling;
    }
  }

  /* ---------- 5. Sticky mobile CTA + back-to-top (show after hero scrolled past) ---------- */
  var stickyCta = document.querySelector('.ba-sticky-cta');
  var backTop = document.querySelector('.ba-back-top');
  var triggerPoint = 600;

  window.addEventListener('scroll', function () {
    var show = window.scrollY > triggerPoint;
    if (stickyCta) stickyCta.classList.toggle('is-visible', show);
    if (backTop) backTop.classList.toggle('is-visible', show);
  }, { passive: true });

  if (backTop) {
    backTop.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
});
